import React, { createContext, useContext, useRef, ReactNode } from 'react';


interface SliderContextType {
  sliderRef: React.RefObject<any>;
  nextSlide: () => void;
  prevSlide: () => void;
  goToSlide: (index: number) => void;
  getCurrentIndex: () => number;
}

const SliderContext = createContext<SliderContextType | undefined>(undefined);

interface SliderProviderProps {
  children: ReactNode;
}

export const SliderProvider: React.FC<SliderProviderProps> = ({ children }) => {
  const sliderRef = useRef<any>(null);

  const nextSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.nextSlide();
    }
  };

  const prevSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.prevSlide();
    }
  };

  const goToSlide = (index: number) => {
    if (sliderRef.current) {
      sliderRef.current.goToSlide(index);
    }
  };

  const getCurrentIndex = () => {
    return sliderRef.current ? sliderRef.current.getCurrentIndex() : 0;
  };

  const value: SliderContextType = {
    sliderRef,
    nextSlide,
    prevSlide,
    goToSlide,
    getCurrentIndex
  };

  return (
    <SliderContext.Provider value={value}>
      {children}
    </SliderContext.Provider>
  );
};

// Hook personalizzato per usare il context
export const useSlider = (): SliderContextType => {
  const context = useContext(SliderContext);
  if (context === undefined) {
    throw new Error('useSlider must be used within a SliderProvider');
  }
  return context;
}; 